import styled, { css } from 'styled-components';

import { token } from '@zillow/constellation';

export const StyledTooltipPopperButtonContainer = styled.span<{ fluid?: boolean }>`
  display: inline-block;

  ${({ fluid }) =>
    fluid &&
    css`
      width: 100%;
    `}

  button.disabled {
    cursor: help;
    box-shadow: none;
    text-decoration: none;

    opacity: ${token('opacities.disabled')};

    :hover {
      text-decoration: none;
    }
  }
`;
